import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, Loader2, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";
import { usePageMeta } from "@/lib/seo";
import { TIERS } from "@/lib/honor";
import { CongratsButton } from "@/components/HonorCongrats";
import { CongratsFans } from "@/components/HonorFans";

const since = (d) => d ? new Date(d).toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }) : null;

const HonorTile = ({ u, i, onChange }) => (
  <div data-testid={`honor-wall-member-${u.user_id}`} style={{ animationDelay: `${i * 70}ms` }}
    className={`tier-${u.tier || "gold"} fade-up honor-card rounded-3xl p-5 flex flex-col items-center text-center gap-2 hover:-translate-y-1 transition-transform`}>
    <span className="honor-chip text-[10px] font-extrabold tracking-[0.2em] px-2.5 py-0.5 rounded-full">{(TIERS[u.tier] || TIERS.gold).label.toUpperCase()}</span>
    <Link to={`/u/${u.user_id}`} data-testid={`honor-wall-link-${u.user_id}`} className="flex flex-col items-center gap-2">
      <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-24 h-24" text="text-3xl" noStory />
      <p className="font-display text-xl font-extrabold honor-name mt-1">{u.name}</p>
    </Link>
    <p className="text-sm font-bold honor-title flex items-center gap-1.5"><Sparkles className="w-4 h-4 shrink-0" /> {u.title}</p>
    {since(u.since) && <p className="text-xs text-slate-400">geehrt seit {since(u.since)}</p>}
    <CongratsButton honor={u} className="mt-2" onDone={(d) => onChange({ ...u, ...d })} />
    <CongratsFans honor={u} />
  </div>
);

export default function HonorWall() {
  usePageMeta({ title: "Ehrenwand" });
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/honor/wall").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="honor-wall-page">
      <header className="tier-gold honor-card rounded-[2rem] px-6 py-8 sm:py-10 text-center relative overflow-hidden">
        <span className="mx-auto w-16 h-16 rounded-full honor-ring flex items-center justify-center"><span className="w-14 h-14 rounded-full bg-white flex items-center justify-center"><Award className="w-8 h-8 text-[#c8962e]" /></span></span>
        <p className="mt-4 text-[11px] font-extrabold tracking-[0.35em] honor-title">ITZPLAY</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold honor-name mt-1" data-testid="honor-wall-title">Ehrenwand</h1>
        <p className="text-sm sm:text-base text-slate-600 mt-3 max-w-xl mx-auto">Hier ehren Saskia & Stefan die Menschen, die unsere Community ganz besonders geprägt haben. Danke für alles! 🤍</p>
      </header>
      {list === null ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-amber-500" /></div>
        : list.length === 0 ? <p className="text-center text-slate-400 py-12" data-testid="honor-wall-empty">Noch keine Ehrenmitglieder – bald wird hier jemand geehrt ✨</p>
          : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="honor-wall-list">{list.map((u, i) => <HonorTile key={u.user_id} u={u} i={i} onChange={(n) => setList((l) => l.map((x) => (x.user_id === n.user_id ? n : x)))} />)}</div>}
    </div>
  );
}
